import { Box, Stack, Typography } from "@mui/material";
import {
  CreditCardOutlined,
  GppGoodOutlined,
  LockOutlined,
  SupportAgentOutlined,
} from "@mui/icons-material";

// Faixa de confiança: os motivos para comprar com tranquilidade.
// Aparece logo abaixo da busca na home e no topo dos resultados.
const ITEMS = [
  {
    icon: LockOutlined,
    title: "Pagamento pela seguradora",
    text: "Sua compra é processada direto pela seguradora escolhida.",
  },
  {
    icon: GppGoodOutlined,
    title: "Seguradoras reguladas",
    text: "Planos de seguradoras registradas na SUSEP.",
  },
  {
    icon: SupportAgentOutlined,
    title: "Assistência 24h",
    text: "Atendimento em português, todos os dias, durante a viagem.",
  },
  {
    icon: CreditCardOutlined,
    title: "Até 12x sem juros",
    text:
      "Parcele no cartão (12x em compras acima de R$ 700) e receba a apólice por e-mail.",
  },
];

// Versão "inline": uma linha discreta de texto cinza (usada nos resultados).
const InlineTrustBar = () => (
  <Stack
    direction="row"
    justifyContent="center"
    sx={{ flexWrap: "wrap", columnGap: { xs: 2, md: 3.5 }, rowGap: 0.75 }}
  >
    {ITEMS.map(({ icon: Icon, title }) => (
      <Stack key={title} direction="row" spacing={0.75} alignItems="center">
        <Icon sx={{ color: "primary.main", fontSize: 18 }} />
        <Typography
          sx={{ fontSize: "0.8rem", color: "text.secondary", fontWeight: 600 }}
        >
          {title}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

const TrustBar = ({ compact = false, inline = false }) =>
  inline ? (
    <InlineTrustBar />
  ) : (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" },
        gap: { xs: 2, md: 3 },
        maxWidth: 1100,
        mx: "auto",
        px: compact ? 0 : 2,
      }}
    >
      {ITEMS.map(({ icon: Icon, title, text }) => (
        <Stack
          key={title}
          direction="row"
          spacing={1.5}
          alignItems="flex-start"
        >
          <Icon
            sx={{
              color: "primary.main",
              fontSize: compact ? 26 : 30,
              mt: 0.25,
            }}
          />
          <Box>
            <Typography
              sx={{ fontWeight: 700, fontSize: compact ? "0.9rem" : "0.95rem" }}
            >
              {title}
            </Typography>
            {!compact && (
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {text}
              </Typography>
            )}
          </Box>
        </Stack>
      ))}
    </Box>
  );

export default TrustBar;
